import Survey from '../components/Survey/Index'
import SurveyComplete from '../components/Survey/Complete'

export default [
  {
    path: '/client/survey/:keyword',
    name: 'survey',
    component: Survey,
  },
  {
    path: '/client/survey/:keyword',
    name: 'survey-confirm',
    component: Survey,
  },
  {
    path: '/client/survey/:keyword/complete',
    name: 'survey-complete',
    component: SurveyComplete,
  },
]
